@if (!showHowdyVideo) {
  <div class="content">
    <app-video-background
      [showAnonymous]="false"
      source="water"
    >
      <a class="explainer-header-back back-button" (click)="goBack()">
        <i class="fa-solid fa-chevron-left"></i>
        <div class="back text">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</div>
      </a>
      <div class="video-content howdy-section">
        <div class="video-content-left">
          <h2 class="content-title">{{ 'WebApp.v1.Explain.AOneMinuteWellBeingCheckIn' | translate }}</h2>
          <p class="content-description">
            {{ 'WebApp.v1.Explain.ByAnswering5SimpleQuestionsEvery2Weeks' | translate }}
          </p>
        </div>
        <div class="video-content-right">
          <div class="rounded-circle" (click)="showHowdyVideo = !showHowdyVideo">
            <i class="play-button fa-solid fa-play"></i>
            <span class="circle-text">{{ 'WebApp.v1.Explain.HowdyIn30Seconds' | translate }}</span>
          </div>
        </div>
      </div>
  
      <div class="arrow-container">
        <img [src]="s3BaseUrl + 'assets/images/Arrow.png'" alt="arrow">
      </div>
    </app-video-background>
  
    <div class="benefits-section">
      <div class="benefits-header">
        <h2 class="benefits-title">{{ 'WebApp.v1.Explain.Benefits' | translate }}</h2>
        <p class="benefits-description">{{ 'WebApp.v1.Explain.ImproveYourWellBeingBy' | translate }}</p>
      </div>
    
      <div class="benefits-grid">
        @for (benefit of [1, 2, 3, 4]; track $index) {
          <div class="benefits-item">
            <div class="checkmark-circle">
              <i class="fa-solid fa-check"></i>
            </div>
            <p class="benefits-text">{{ 'WebApp.v1.Explain.Benefits.Benefit' + ($index + 1) | translate }}</p>
          </div>
        }
      </div>
    </div>
  
    <app-video-background
      [showLogo]="false"
      [showAnonymous]="false"
      source="woman_on_beach"
    >
      <div class="video-content awareness">
        <div class="video-content-left">
          <h2 class="content-title awareness">{{ 'WebApp.v1.Explain.TrackYourWellBeing' | translate }}</h2>
          <p class="content-description awareness">
            {{ 'WebApp.v1.Explain.Awareness.Text' | translate }}
          </p>
        </div>
        <div class="video-content-right">
          <img class="chart awareness" [src]="s3BaseUrl + 'assets/images/chart.png'" alt="chart">
        </div>
      </div>
    </app-video-background>
  
    <div class="info-container">
      <div class="info-header">
        <h2 class="info-title">{{ 'WebApp.v1.Explain.AccessToHelp' | translate }}</h2>
        <p class="info-description">{{ 'WebApp.v1.Explain.AccessToHelp.Text' | translate }}</p>
      </div>
    </div>
  
    <app-video-background source="mind">
      <div class="video-content start">
  
        <div class="start-container">
          <h2 class="content-title start">{{ 'WebApp.v1.Auth.Login.HeadLine' | translate }}</h2>
  
          <div class="start-button-container">
            <p class="content-description start">
              {{ 'WebApp.v1.Explain.SeeHowEasyItIs' | translate }}
            </p>

            <app-button
              class="custom-button"
              [label]="buttonLabel | translate"
              [fontSize]="32"
              [iconLeft]="buttonIcon"
              [showOutlineOnHover]="true"
              [backgroundColor]="buttonColor"
              [routerLink]="buttonLink"
            ></app-button>
          </div>
        </div>
      </div>
    </app-video-background>
  </div>
} @else {
  <div class="video-container howdy-section" background="">
    <i class="fa-solid fa-xmark close-button" (click)="showHowdyVideo = false"></i>
    <video class="video" controls autoplay>
      <source [src]="s3BaseUrl + 'assets/videos/Howdy Wellbeing Intro ' + language + videoFormat" type="video/mp4">
    </video>
  </div>
}
